<template>
 
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import headr from '@/components/head/index'
  import bottom from '@/components/bottom/index'
  export default {
    name: 'App',
    components: {
      headr,
      bottom
    },
  }

</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #2c3e50;
    margin: 0px;
    padding: 0px;
  }

  body {
    margin: 0px;
    padding: 0px;
  }

  html {
    margin: 0px;
    padding: 0px;
  }
a {
  color: inherit; /* 继承父元素的文字颜色 */
  text-decoration: none; /* 去掉下划线 */
}
</style>



// WEBPACK FOOTER //
// src/App.vue